import httpHelper from '../../../../utils/httpHelper';
import { appConfig } from '../../../../constants/appConfig';

const service = {

  async getCompanyList(params) {
    const endPoint = `company/getCompanyList`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  },

  async getCompanyById(params) {
    const endPoint = `company/findById?id=${params.id}`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async saveCompany(payload) {
    const endPoint = 'company/saveCompany';
    const result = await httpHelper.makePostRequest(
      appConfig.baseUrl,
      endPoint,
      payload,
    );
    return result;
  },

  async deleteCompany(params) {
    const endPoint = `company/delete?id=${params.id}`;
    const result = await httpHelper.makeDeleteRequest(
      appConfig.baseUrl,
      endPoint,
    );
    return result;
  },

  async updateCompany(payload) {
    const endPoint = `company/updateCompany?companyId=${payload.companyId}`;
    const result = await httpHelper.makePutRequest(
      appConfig.baseUrl,
      endPoint,
      payload.data
    );
    return result;
  },

  async getCompanyWithSearch(params) {
    const endPoint = `company/findCompanySearch`;
    const result = await httpHelper.makeGetRequest(
      appConfig.baseUrl,
      endPoint,
      params,
    );
    return result;
  }

};

export default service;
